import React, { useState, useEffect } from "react";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  useNavigate,
  Navigate,
} from "react-router-dom"; // Ajout de useNavigate

import { HelmetProvider } from "react-helmet-async";

import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import AdminLogin from "./admin/AdminLogin";
import AdminPanel from "./admin/AdminPanel";
import Page from "./pages/Page"; // Page générique pour les autres pages
import { settings } from "./data/settings";
import { ThemeProvider } from "@mui/material/styles";
import theme from "./theme"; // Importation du thème
import CookieBanner from "./components/CookieBanner";
import PageMentionsLegales from "./pages/PageMentionsLegales";

const App = () => {
  const [currentSettings, setCurrentSettings] = useState(null);
  const [authenticated, setAuthenticated] = useState(
    localStorage.getItem("admin_authenticated") === "true"
  );

  useEffect(() => {
    const fetchSettings = async () => {
      setCurrentSettings(settings);
    };
    fetchSettings();
  }, []);

  if (!currentSettings) return <div>Chargement...</div>;

  return (
    <ThemeProvider theme={theme}>
      <HelmetProvider>
        <Router>
          <Navbar settings={currentSettings} pages={currentSettings.pages} />
          <CookieBanner />
          <Routes>
            {/* Redirection de / vers /salon 
          <Route path="/" element={<Navigate to="/salon" replace />} />*/}

            {/* Routes dynamiques pour chaque page définie dans settings.pages */}
            {Object.keys(currentSettings.pages).map((pageKey, index) => {
              const page = currentSettings.pages[pageKey];

              if (page.component) {
                return (
                  <Route
                    key={pageKey}
                    path={page?.path ?? `/${pageKey}`}
                    element={page.component}
                  />
                );
              } else {
                return (
                  <Route
                    key={pageKey}
                    path={page?.path ?? `/${pageKey}`}
                    element={<Page pageKey={pageKey} />}
                  />
                );
              }
            })}

            <Route path="/mentions-legales" element={<PageMentionsLegales />} />

            <Route
              path="/admin"
              element={
                authenticated ? (
                  <AdminPanel
                    settings={currentSettings}
                    setAuthenticated={setAuthenticated}
                  />
                ) : (
                  <AdminLogin setAuthenticated={setAuthenticated} />
                )
              }
            />
            <Route path="/*" element={<Navigate to="/" replace />} />
          </Routes>
          <Footer />
        </Router>
      </HelmetProvider>
    </ThemeProvider>
  );
};

export default App;
